// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"ca4799b4","382":"44693d2a","685":"c293b379","896":"7b150409"}[chunkId] + ".chunk.js";
};